/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     noteTypes
//   Details:    note Types constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 104762 28/02/20 JC       New
//-------------------------------------------------------
*/

export const noteTypes = {
    text: 0,
    html: 1
};
